import { render, staticRenderFns } from "./notifications.page.vue?vue&type=template&id=2d3c1b28&"
import script from "./notifications.page.vue?vue&type=script&lang=ts&"
export * from "./notifications.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports